import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import ReserveRequest from "../../magData/Train/ReserveRequest";
import ReserveResponse from "../../magData/Train/ReserveResponse";

function TrainReservePage(props) {

  return (
    <>
      <Container fluid>
        <Row>
          <Col sm={12}>
            <p className="page-title">Train Reserve Method</p>
          </Col>
          <Col sm={12}>
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/Train/reserve</p>
          </Col>
          <Col sm={12}>
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <p>Body Parameters</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <span className="code-section-title">
              Request Formats - application/json, text/json
            </span>
          </Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(ReserveRequest, null, 2)}
            </pre>
          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12}>
            <p>Response Information</p>
          </Col>
          <Col sm={12}>
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>AdultCount</td>
                  <td>
                    <p>Number of Adults</p>
                  </td>
                  <td>
                    integer
                  </td>
                  <td>
                    <p>Required</p>
                  </td>
                </tr>
                <tr>
                  <td>ChildCount</td>
                  <td>
                    <p>Number of Childs</p>
                  </td>
                  <td>
                    integer
                  </td>
                  <td>
                    <p>Required</p>
                  </td>
                </tr>
                <tr>
                  <td>InfantCount</td>
                  <td>
                    <p>Number of Infants</p>
                  </td>
                  <td>
                    integer
                  </td>
                  <td>
                    <p>Required</p>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <span className="code-section-title">
              Response Formats - application/json, text/json
            </span>
          </Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(ReserveResponse, null, 2)}
            </pre>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default TrainReservePage;